<template>
  <b-container fluid class="no-bottom">
    <backlink />
    <h1>
      <div class="indicator">
        {{ items.length}}
        <i class="far fa-long-arrow-right fa-xs"></i>
      </div>Préparations
      <br />en attente
    </h1>

    <b-tabs content-class="mt-3">
      <b-tab :title="'Passé ('+oldItems.length+')'">
        <div class="table-wrapper">
          <b-table
            ref="table"
            hover
            show-empty
            :fields="fields"
            :items="oldItems"
            :busy="isBusy"
            sort-by="renting.renting_number"
            :sort-desc="true"
          >
            <template slot="table-busy">
              <div class="text-center my-2">
                <div v-if="isBusy" class="loader"></div>Les données sont en cours de chargement...
              </div>
            </template>
            <template slot="empty" slot-scope="scope">
              <div class="text-center mt-2">Cette liste est vide pour le moment</div>
            </template>

            <template slot="renting.renting_number" slot-scope="data">
              <router-link
                v-if="$store.getters['auth/isAuthorized']('renting-preparation_show')"
                :to="{name: 'RentingPreparationMobileDetail', params: {id: data.item.id}}"
              >{{ data.value }}</router-link>
              <template v-else>{{ data.value }}</template>
            </template>
          </b-table>
        </div>
      </b-tab>
      <b-tab :title="'Jour ('+todayItems.length+')'" active>
        <div class="table-wrapper">
          <b-table
            ref="table"
            hover
            show-empty
            :fields="fields"
            :items="todayItems"
            :busy="isBusy"
            sort-by="renting.renting_number"
            :sort-desc="true"
          >
            <template slot="table-busy">
              <div class="text-center my-2">
                <div v-if="isBusy" class="loader"></div>Les données sont en cours de chargement...
              </div>
            </template>
            <template slot="empty" slot-scope="scope">
              <div class="text-center mt-2">Cette liste est vide pour le moment</div>
            </template>

            <template slot="renting.renting_number" slot-scope="data">
              <router-link
                v-if="$store.getters['auth/isAuthorized']('renting-preparation_show')"
                :to="{name: 'RentingPreparationMobileDetail', params: {id: data.item.id}}"
              >{{ data.value }}</router-link>
              <template v-else>{{ data.value }}</template>
            </template>
          </b-table>
        </div>
      </b-tab>
      <b-tab :title="'A venir ('+nextItems.length+')'">
        <div class="table-wrapper">
          <b-table
            ref="table"
            hover
            show-empty
            :fields="fields"
            :items="nextItems"
            :busy="isBusy"
            sort-by="renting.renting_number"
            :sort-desc="true"
          >
            <template slot="table-busy">
              <div class="text-center my-2">
                <div v-if="isBusy" class="loader"></div>Les données sont en cours de chargement...
              </div>
            </template>
            <template slot="empty" slot-scope="scope">
              <div class="text-center mt-2">Cette liste est vide pour le moment</div>
            </template>

            <template slot="renting.renting_number" slot-scope="data">
              <router-link
                v-if="$store.getters['auth/isAuthorized']('renting-preparation_show')"
                :to="{name: 'RentingPreparationMobileDetail', params: {id: data.item.id}}"
              >{{ data.value }}</router-link>
              <template v-else>{{ data.value }}</template>
            </template>
          </b-table>
        </div>
      </b-tab>
    </b-tabs>
  </b-container>
</template>

<script>
export default {
  name: "RentingPreparationMobileList",
  data() {
    return {
      fields: [
        {
          key: "renting.renting_number",
          label: "Numéro de demande",
        },
        {
          key: "preparation_date",
          label: "Préparation",
        },
        {
          key: "wished_delivery_date",
          label: "Livraison",
        },
      ],
      isBusy: false,
    };
  },
  computed: {
    // On lie 'items' au données du store (sauf si des données sont passées du parent)
    items: function () {
      return this.$store.getters["renting_preparation/getByStatusSlug"]([
        "renting-preparation-en-attente-de-preparation",
        "renting-preparation-prete-pour-expedition",
      ]).filter(
        (item) =>
          item.preparator &&
          item.preparator.id == this.$store.getters["auth/id"]
      );
    },
    oldItems: function () {
      return this.items
        .filter(
          (item) =>
            !item.preparation_date ||
            this.$moment(item.preparation_date).format("YYYY-MM-DD") <
              this.$moment().format("YYYY-MM-DD")
        )
        .map((item) => ({
          ...item,
          preparation_date: this.date(item.preparation_date),
          wished_delivery_date: this.date(item.renting.wished_delivery_date),
        }));
    },
    todayItems: function () {
      return this.items
        .filter(
          (item) =>
            item.preparation_date &&
            this.$moment(item.preparation_date).format("YYYY-MM-DD") ==
              this.$moment().format("YYYY-MM-DD")
        )
        .map((item) => ({
          ...item,
          preparation_date: this.date(item.preparation_date),
          wished_delivery_date: this.date(item.renting.wished_delivery_date),
        }));
    },
    nextItems: function () {
      return this.items
        .filter(
          (item) =>
            item.preparation_date &&
            this.$moment(item.preparation_date).format("YYYY-MM-DD") >
              this.$moment().format("YYYY-MM-DD")
        )
        .map((item) => ({
          ...item,
          preparation_date: this.date(item.preparation_date),
          wished_delivery_date: this.date(item.renting.wished_delivery_date),
        }));
    },
  },
  mounted() {
    // On demande au store de se mettre à jour à partir de l'API
    this.$store
      .dispatch("renting_preparation/getMineByStatusSlug", [
        "renting-preparation-en-attente-de-preparation",
      ])
      .then(() => (this.isBusy = false));

    // Si il n'y a pas déjà des items dans le store, on affiche le loader le temps que le store se mette à jour
    if (!this.items || !this.items.length) {
      this.isBusy = true;
    }
  },
  methods: {
    date(value) {
      return this.$moment(value).format("DD-MM-YYYY");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/RentingPreparationMobile/RentingPreparationMobileList.vue